export default {
  SET_USER(state, user) {
    state.user = user;
  },
  SET_TOKEN(state, token) {
    state.token = token;
  },
  SET_PHONE(state, phone) {
    state.phone = phone;
  },
  SET_SERVICES(state, services) {
    state.services = services;
  },
  SET_COUNTIES(state, counties) {
    state.counties = counties;
  },
  SET_LOADING(state, status) {
    state.loading = status;
  },
  SET_INFO(state, status) {
    state.info = status;
  },
  SET_ERROR(state, status) {
    state.error = status;
  },
  SET_ROUTE_VIEW(state, value) {
    state.routeView = value;
  },
  SET_CONFIRM_TOKEN(state, token) {
    state.confirmToken = token;
  },
  SET_CHANGE_PASSWORD(state, change) {
    state.changePassword = change;
  },
  SET_ACTIVE_COUNTY(state, county) {
    state.activeCounty = county;
  },
  SET_ID_NUMBER(state, idNo) {
    state.idNo = idNo;
  },
  SET_OLD_PASSWORD(state, oldPassword) {
    state.oldPassword = oldPassword;
  }
};



// WEBPACK FOOTER //
// ./src/store/mutations.js